import {updateFilters} from './updateFilters';
import {updateSort} from './updateSort';

export default {
  Mutation: {
    updateFilters,
    updateSort
  }
}
